/*
 * @Author: your name
 * @Date: 2021-03-01 14:32:18
 * @LastEditTime: 2021-03-08 14:38:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\programEditing\index.js
 */
import state from './state';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

const store = {
  state,
  mutations,
  getters,
  actions
};

export default store;